(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cdx-collection-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Katalog-Anfrage als Modal mit eingebettetem Klaviyo-Formular.
     Klaviyo rendert seine Embeds beim Seiten-Scan in das Container-Div; ist es zum
     Zeitpunkt des Oeffnens noch leer, wird ueber _klOnsite ein erneuter Lauf
     angestossen. Bleibt es leer, erscheint der Fallback-Hinweis. */
  function initKatalogModal(root) {
    var modal = root.querySelector('[data-katalog-modal]');
    var opener = root.querySelector('[data-katalog-open]');
    if (!modal || !opener) return;

    var wrap = modal.querySelector('[data-katalog-form]');
    var fallback = modal.querySelector('[data-katalog-fallback]');
    /* Der eigentliche Klaviyo-Container ist das Div mit der klaviyo-form-<id>-Klasse,
       egal ob es aus dem Metafeld kam oder hier gebaut wurde. */
    var kl = wrap ? wrap.querySelector('[class*="klaviyo-form-"]') : null;
    var lastFocus = null;

    function rendered() { return !!(kl && kl.children.length); }
    function formId() {
      var m = kl && (kl.className || '').match(/klaviyo-form-([A-Za-z0-9_-]+)/);
      return m ? m[1] : '';
    }

    function nudgeKlaviyo() {
      if (rendered()) return;
      var id = formId();
      if (id) {
        try {
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', id]);
        } catch (e) {}
      }
      setTimeout(function () {
        if (fallback) fallback.hidden = rendered();
      }, 2500);
    }

    function open() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      if (fallback) fallback.hidden = true;
      nudgeKlaviyo();
      var focusable = modal.querySelector('input,button,select,textarea,a[href]');
      if (focusable) setTimeout(function () { focusable.focus(); }, 60);
    }
    function close() {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    opener.addEventListener('click', function (e) { e.preventDefault(); open(); });
    var closers = modal.querySelectorAll('[data-katalog-close]');
    for (var i = 0; i < closers.length; i++) closers[i].addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
    /* Klaviyo meldet den Abschluss – Modal danach schliessen */
    window.addEventListener('klaviyoForms', function (e) {
      if (e.detail && e.detail.type === 'submit' && !modal.hidden) setTimeout(close, 2000);
    });
  }

  function init(root) {
    // Eingeblendet wird die ganze Button-Zeile als ein Stueck, nicht jeder
    // Button fuer sich. So starten Finder und Katalog gemeinsam und die Zeile
    // ruckelt beim Erscheinen nicht. Steht nur der Katalog-Button darin, ist
    // die Zeile genau so gross wie er, die Bewegung sieht aus wie bisher.
    var cat = root.querySelector('.cdx-chero-btnrow');
    if (cat && 'IntersectionObserver' in window && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
      cat.classList.add('cdx-pre');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.remove('cdx-pre'); io.unobserve(en.target); }
        });
      }, { threshold: 0.25 });
      io.observe(cat);
    }

    initKatalogModal(root);

    var wrap = root.querySelector('[data-cdx-readmore]');
    if (!wrap) return;
    var btn = wrap.querySelector('[data-cdx-more]');
    var txt = wrap.querySelector('.cdx-chero-desc-text');
    var label = btn ? btn.querySelector('[data-more-label]') : null;
    if (!btn || !txt) return;
    if (txt.scrollHeight <= txt.clientHeight + 2) { btn.style.display = 'none'; return; }
    btn.addEventListener('click', function () {
      var open = wrap.classList.toggle('is-open');
      btn.classList.toggle('is-open', open);
      if (label) label.textContent = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
    });
  }
  function boot() {
    var heroes = document.querySelectorAll('[data-cdx-chero]');
    for (var i = 0; i < heroes.length; i++) init(heroes[i]);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cdx-collection-seo"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCarousel(root) {
    var track = root.querySelector('[data-cseo-track]');
    if (!track) return;
    var items = track.querySelectorAll('.cdx-cseo-ti');
    var dots = root.querySelectorAll('[data-cseo-dot]');
    if (items.length < 2) return;
    var idx = 0, timer = null, paused = false, st = null;
    function isMobile() { return window.matchMedia('(max-width:749px)').matches; }
    function setActive(i) { for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-active', d === i); }
    function go(i) { idx = (i + items.length) % items.length; track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' }); setActive(idx); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() { stop(); if (!isMobile()) return; timer = setInterval(function () { if (!paused) go(idx + 1); }, 3800); }
    track.addEventListener('scroll', function () {
      clearTimeout(st);
      st = setTimeout(function () { var i = Math.round(track.scrollLeft / track.clientWidth); if (i !== idx) { idx = i; setActive(i); } }, 80);
    });
    for (var d = 0; d < dots.length; d++) { (function (n) { dots[n].addEventListener('click', function () { go(n); }); })(d); }
    track.addEventListener('pointerdown', function () { paused = true; });
    window.addEventListener('pointerup', function () { paused = false; });
    window.addEventListener('resize', function () { start(); });
    setActive(0);
    start();
  }
  // FAQ auf-/zuklappen — gleiches Verhalten wie auf der Produktseite
  function initFaq(root) {
    var faq = root.querySelector('[data-cdx-cseo-faq]');
    if (!faq) return;
    faq.querySelectorAll('[data-faq-q]').forEach(function (q) {
      q.addEventListener('click', function () { q.parentElement.classList.toggle('open'); });
    });
  }
  function init(root) {
    if (!root || root.dataset.cseoReady) return;
    initCarousel(root);
    initFaq(root);
    var wrap = root.querySelector('[data-cdx-readmore]');
    if (!wrap) { root.dataset.cseoReady = '1'; return; }
    var btn = wrap.querySelector('[data-cdx-more]');
    var txt = wrap.querySelector('.cdx-cseo-desc-text');
    var label = btn ? btn.querySelector('[data-more-label]') : null;
    if (!btn || !txt) { root.dataset.cseoReady = '1'; return; }
    if (txt.scrollHeight <= txt.clientHeight + 2) { btn.style.display = 'none'; root.dataset.cseoReady = '1'; return; }
    btn.addEventListener('click', function () {
      var open = wrap.classList.toggle('is-open');
      btn.classList.toggle('is-open', open);
      if (label) label.textContent = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
    });
    root.dataset.cseoReady = '1';
  }
  function boot() {
    var els = document.querySelectorAll('[data-cdx-cseo]');
    for (var i = 0; i < els.length; i++) init(els[i]);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-cdx-cseo]');
    if (r) { r.dataset.cseoReady = ''; init(r); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
